module.exports = __webpack_public_path__ + "img/cart3.8721668d.svg";